import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5701%3A11684
 *
 * @param {SvgIconProps} props - svg props
 */
export const HistoryIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z' fill={color}/>
            <path d='M11 4C11 3.44772 11.4477 3 12 3C12.5523 3 13 3.44772 13 4V11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H13H12.5C11.6716 13 11 12.3284 11 11.5V11V4Z' fill='white'/>
        </SvgIcon>
    )
}

export default HistoryIcon
